import React, { useState, useEffect } from "react";
import s from "./index.module.css";

//Servicios
import couponsService from "../../../api/delivery/couponsService";

//Assets
import { setSelectedCoupon } from "../../../store/slices/couponsSlice";
import { Currency } from "../../../helpers/currencyConvert";
import { dateFormats } from "../../../helpers/convertDate";
import Pager from "../../Shared/Pagination/Pagination";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import { t } from "i18next";

import {
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  CircularProgress,
  Snackbar,
  Alert,
  ToggleButtonGroup,
  ToggleButton,
  Tabs,
  Tab,
  Box,
} from "@mui/material";
import StyleRoundedIcon from "@mui/icons-material/StyleRounded";
import { PendingOrdersList } from "../AgencyOrders/Backoffice/PendingOrdersList";
import ConfigsSearcher from "../../../config/Configs";
import { FEATURE_KEYS } from "../../../config/featureFlags";

const cellStyles = {
  fontFamily: "Roboto, sans-serif",
  fontSize: ".9rem",
  fontWeight: "400",
  borderBottom: "1px solid rgba(0, 0, 0, 0.455)",
  cursor: "pointer",
};

const Cupones = () => {
  const { textColor } = useSelector((state) => state.local);
  const { activeOrganization } = useSelector((state) => state.gamma);

  const { isFeatureEnabled } = ConfigsSearcher();
  const showPedidos = isFeatureEnabled(FEATURE_KEYS.MENU_PEDIDOS_ENABLED);

  const { formatDate } = dateFormats();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const [items, setItems] = useState([]);
  const [status, setStatus] = useState("none");
  const [loading, setLoading] = useState(false);
  const [errorFetch, setErrorFetch] = useState(false);

  //Paginacion
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [pageCustom, setPageCustom] = useState(1);
  const [sort, setSort] = useState({
    criteria: "DESC",
    field: "game.name",
  });
  
  // Leer el tab de la URL, por defecto 0 (Stock de Cupones)
  const tabFromUrl = searchParams.get("tab");
  const [currentTab, setCurrentTab] = useState(tabFromUrl ? parseInt(tabFromUrl) : 0);

  // Sincronizar el tab cuando cambia la URL
  useEffect(() => {
    const tabFromUrl = searchParams.get("tab");
    if (tabFromUrl !== null) {
      const tabValue = parseInt(tabFromUrl);
      if (tabValue !== currentTab) {
        setCurrentTab(tabValue);
      }
    }
  }, [searchParams]);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
    // Actualizar la URL con el nuevo tab
    const newSearchParams = new URLSearchParams(searchParams);
    if (newValue === 0) {
      newSearchParams.delete("tab");
    } else {
      newSearchParams.set("tab", newValue.toString());
    }
    setSearchParams(newSearchParams);
  };

  const handleSort = (item) => {
    setSort((prev) => ({
      criteria:
        prev.field === item
          ? prev.criteria === "DESC"
            ? "ASC"
            : "DESC"
          : "DESC",
      field: item,
    }));
  };
  const getData = () => {
    setLoading(true);
    couponsService
      .getLotteryStockItems(
        page,
        pageSize,
        sort,
        status,
      )
      .then((res) => {
        setItems(res.content);
        setTotalPages(res.totalPages);
      })
      .then(() => setLoading(false))
      .catch(() => {
        setErrorFetch(true);
        setLoading(false);
      });
  };

  useEffect(() => {
    getData();
  }, [page, pageSize, status, sort]);

  return (
    <Grid item container xs={12} className={s.container}>
      <Grid
        item
        xs={11}
        container
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
          mt: { xs: 2 },
        }}
      >
        <Grid item xs={12} lg={8} className={s.titleContainer}>
          <StyleRoundedIcon
            sx={{ fontSize: "1.8rem", color: "primary.main" }}
          />
          <h4>{t("couponsStock")}</h4>
        </Grid>
      </Grid>

      <Grid item xs={12} sx={{ mb: 2, mt: 2 }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs value={currentTab} onChange={handleTabChange}>
                <Tab label={t("couponsStock") || "Stock de Cupones"} />
                {showPedidos && <Tab label="Pedidos Pendientes" />}
              </Tabs>
            </Box>
      </Grid>

      {currentTab === 0 && (
        <>
        <Grid
          item
          xs={11}
          container
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Grid
            item
            xs={12}
            lg={4}
            sx={{
              display: "flex",
              justifyContent: { lg: "flex-end", xs: "flex-start" },
              alignItems: "center",
              mb: { xs: 2 },
            }}
          >
          <p
            style={{
              margin: 0,
              marginRight: "1rem",
              fontSize: "1.1rem",
              fontWeight: 300,
            }}
          >
            {t("state")}
          </p>
          <ToggleButtonGroup
            value={status}
            onChange={(e, v) => {
              if (v !== null) {
                setStatus(v);
              }
            }}
            size={"small"}
            exclusive
            color="primary"
          >
            <ToggleButton value="none">{t("all")}</ToggleButton>
            <ToggleButton value="true">{t("active")}</ToggleButton>
            <ToggleButton value="false">{t("compromised")}</ToggleButton>
          </ToggleButtonGroup>
        </Grid>
      </Grid>

      {loading ? (
        <Grid
          item
          xs={11}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "300px",
          }}
        >
          <CircularProgress size="3rem" />
        </Grid>
      ) : items?.length ? (
        <Grid item xs={11}>
          <TableContainer className={s.tableContainer}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      ...cellStyles,
                      cursor: "pointer",
                      fontWeight: 500,
                      color: textColor,
                      backgroundColor: "primary.main",
                    }}
                    onClick={() => handleSort("state")}
                  >{`${t("state")} ${sort.field === "state" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
                  <TableCell
                    sx={{
                      ...cellStyles,
                      cursor: "pointer",
                      fontWeight: 500,
                      color: textColor,
                      backgroundColor: "primary.main",
                    }}
                    onClick={() => handleSort("game.name")}
                  >{`${t("game")} ${sort.field === "game.name" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
                  <TableCell
                    sx={{
                      ...cellStyles,
                      cursor: "pointer",
                      fontWeight: 500,
                      color: textColor,
                      backgroundColor: "primary.main",
                    }}
                    onClick={() => handleSort("raffle.number")}
                  >{`${t("product")} ${sort.field === "raffle.number" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
                  <TableCell
                    sx={{
                      ...cellStyles,
                      cursor: "pointer",
                      fontWeight: 500,
                      color: textColor,
                      backgroundColor: "primary.main",
                    }}
                    onClick={() => handleSort("raffle.raffleDate")}
                  >{`${t("drawDate")} ${sort.field === "raffle.raffleDate" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
                  <TableCell
                    sx={{
                      ...cellStyles,
                      cursor: "pointer",
                      fontWeight: 500,
                      color: textColor,
                      backgroundColor: "primary.main",
                    }}
                    onClick={() => handleSort("raffle.price")}
                  >{`${t("price")} ${sort.field === "raffle.price" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
                  <TableCell
                    sx={{
                      ...cellStyles,
                      cursor: "pointer",
                      fontWeight: 500,
                      color: textColor,
                      backgroundColor: "primary.main",
                    }}
                    onClick={() => handleSort("totalitems")}
                  >{`${t("stock")} ${sort.field === "totalitems" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {items?.map((item, i) => {
                  return (
                    <React.Fragment key={i}>
                      <TableRow
                        sx={{ "&:hover": { backgroundColor: "primary.light" } }}
                        onClick={() => {
                          if (item.state === "Comprometido") {
                            Swal.fire(
                              t("stockEngagedTitle"),
                              t("stockEngagedText"),
                              "warning",
                            );
                          } else {
                            dispatch(setSelectedCoupon(item));
                            navigate(
                              `./${item?.game?.name}/${item?.game?.id}/${item?.raffle?.id}/${item?.raffle?.number || item?.raffle?.serie}`,
                            );
                          }
                        }}
                      >
                        <TableCell sx={{ ...cellStyles }}>
                          {item?.state || "-"}
                        </TableCell>
                        <TableCell sx={{ ...cellStyles }}>
                          {item?.game?.name || "-"}
                        </TableCell>
                        <TableCell sx={{ ...cellStyles }}>
                          {item?.raffle?.number
                            ? `${t("drawNumber")}: ${item?.raffle?.number}`
                            : item?.raffle?.serie
                              ? `${t("serie")}: ${item?.raffle?.serie}`
                              : "-"}
                        </TableCell>
                        <TableCell sx={{ ...cellStyles }}>
                          {formatDate(item?.raffle?.raffleDate) || "-"}
                        </TableCell>
                        <TableCell sx={{ ...cellStyles }}>
                          <Currency value={item?.raffle?.price} />
                        </TableCell>
                        <TableCell sx={{ ...cellStyles }}>
                          {item?.totalitems}
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      ) : (
        <Grid
          item
          xs={11}
          sx={{
            fontSize: "1.8rem",
            fontWeight: "300",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "300px",
          }}
        >
          {t("noResults")}
        </Grid>
      )}

      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mb: 5,
        }}
      >
        <Pager
          pageSize={pageSize}
          setPageSize={setPageSize}
          page={page}
          setPage={setPage}
          totalPages={totalPages}
          pageCustom={pageCustom}
          setPageCustom={setPageCustom}
        />
      </Grid>

      <Snackbar
        open={errorFetch}
        autoHideDuration={6000}
        onClose={() => setErrorFetch(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <Alert
          variant="filled"
          onClose={() => setErrorFetch(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {t("tryInOtherMoment")}
        </Alert>
      </Snackbar>
      </>
      )}

          {showPedidos && currentTab === 1 && (
            <Grid item xs={12}>
              <PendingOrdersList />
            </Grid>
          )}
    </Grid>
  );
};

export default Cupones;
